/* tslint:disable */
/* eslint-disable */
/**
 * MinSide.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type AccessRequestRequest,
    AccessRequestRequestFromJSON,
    AccessRequestRequestToJSON,
} from '../models/AccessRequestRequest';
import {
    type AccessRequestResponse,
    AccessRequestResponseFromJSON,
    AccessRequestResponseToJSON,
} from '../models/AccessRequestResponse';
import {
    type AccessRequestResponsePagedResult,
    AccessRequestResponsePagedResultFromJSON,
    AccessRequestResponsePagedResultToJSON,
} from '../models/AccessRequestResponsePagedResult';
import {
    type AccessRequestSearchOrderBy,
    AccessRequestSearchOrderByFromJSON,
    AccessRequestSearchOrderByToJSON,
} from '../models/AccessRequestSearchOrderBy';
import {
    type AccessRequestUpdateStatusNotificationPreviewResponse,
    AccessRequestUpdateStatusNotificationPreviewResponseFromJSON,
    AccessRequestUpdateStatusNotificationPreviewResponseToJSON,
} from '../models/AccessRequestUpdateStatusNotificationPreviewResponse';
import {
    type AccessRequestUpdateStatusRequest,
    AccessRequestUpdateStatusRequestFromJSON,
    AccessRequestUpdateStatusRequestToJSON,
} from '../models/AccessRequestUpdateStatusRequest';
import {
    type AccessRequestUpdateStatusResponse,
    AccessRequestUpdateStatusResponseFromJSON,
    AccessRequestUpdateStatusResponseToJSON,
} from '../models/AccessRequestUpdateStatusResponse';
import {
    type ApplicationResponse,
    ApplicationResponseFromJSON,
    ApplicationResponseToJSON,
} from '../models/ApplicationResponse';
import {
    type ApprovedAccessOrderBy,
    ApprovedAccessOrderByFromJSON,
    ApprovedAccessOrderByToJSON,
} from '../models/ApprovedAccessOrderBy';
import {
    type ApprovedAccessResponsePagedResult,
    ApprovedAccessResponsePagedResultFromJSON,
    ApprovedAccessResponsePagedResultToJSON,
} from '../models/ApprovedAccessResponsePagedResult';
import {
    type ForbidResult,
    ForbidResultFromJSON,
    ForbidResultToJSON,
} from '../models/ForbidResult';
import {
    type GenericValidationError,
    GenericValidationErrorFromJSON,
    GenericValidationErrorToJSON,
} from '../models/GenericValidationError';
import {
    type NotFoundResult,
    NotFoundResultFromJSON,
    NotFoundResultToJSON,
} from '../models/NotFoundResult';
import {
    type SortOrder,
    SortOrderFromJSON,
    SortOrderToJSON,
} from '../models/SortOrder';

export interface ApiAccessRequestsApprovedGetRequest {
    pageNumber?: any;
    pageSize?: any;
    sortOrder?: SortOrder;
    orderField?: ApprovedAccessOrderBy;
    firstName?: string;
    surname?: string;
    roleIds?: Array<any>;
    permissionIds?: Array<any>;
    applicationIds?: Array<string>;
    includeGlobalApplications?: boolean;
}

export interface ApiAccessRequestsAssignedUsersGetRequest {
    pageNumber?: any;
    pageSize?: any;
    sortOrder?: SortOrder;
    orderField?: ApprovedAccessOrderBy;
    firstName?: string;
    surname?: string;
    roleIds?: Array<any>;
    applicationIds?: Array<string>;
    includeGlobalApplications?: boolean;
}

export interface ApiAccessRequestsGetRequest {
    pageNumber?: any;
    pageSize?: any;
    sortOrder?: SortOrder;
    orderField?: AccessRequestSearchOrderBy;
}

export interface ApiAccessRequestsIdRequestExtensionPutRequest {
    id: any;
}

export interface ApiAccessRequestsPostRequest {
    accessRequestRequest: AccessRequestRequest;
}

export interface ApiAccessRequestsUuidStatusPreviewPostRequest {
    uuid: string;
    accessRequestUpdateStatusRequest: AccessRequestUpdateStatusRequest;
}

export interface ApiAccessRequestsUuidStatusPutRequest {
    uuid: string;
    accessRequestUpdateStatusRequest: AccessRequestUpdateStatusRequest;
}

export interface GetAccessRequestByUuidRequest {
    uuid: string;
}

/**
 * 
 */
export class AccessRequestsApi extends runtime.BaseAPI {

    /**
     * Creates request options for apiAccessRequestsApplicableApplicationsGet without sending the request
     */
    async apiAccessRequestsApplicableApplicationsGetRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/access-requests/applicable-applications`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async apiAccessRequestsApplicableApplicationsGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ApplicationResponse>>> {
        const requestOptions = await this.apiAccessRequestsApplicableApplicationsGetRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ApplicationResponseFromJSON));
    }

    /**
     */
    async apiAccessRequestsApplicableApplicationsGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ApplicationResponse>> {
        const response = await this.apiAccessRequestsApplicableApplicationsGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for apiAccessRequestsApprovedGet without sending the request
     */
    async apiAccessRequestsApprovedGetRequestOpts(requestParameters: ApiAccessRequestsApprovedGetRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['pageNumber'] != null) {
            queryParameters['PageNumber'] = requestParameters['pageNumber'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['PageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['sortOrder'] != null) {
            queryParameters['SortOrder'] = requestParameters['sortOrder'];
        }

        if (requestParameters['orderField'] != null) {
            queryParameters['OrderField'] = requestParameters['orderField'];
        }

        if (requestParameters['firstName'] != null) {
            queryParameters['firstName'] = requestParameters['firstName'];
        }

        if (requestParameters['surname'] != null) {
            queryParameters['surname'] = requestParameters['surname'];
        }

        if (requestParameters['roleIds'] != null) {
            queryParameters['roleIds'] = requestParameters['roleIds'];
        }

        if (requestParameters['permissionIds'] != null) {
            queryParameters['permissionIds'] = requestParameters['permissionIds'];
        }

        if (requestParameters['applicationIds'] != null) {
            queryParameters['applicationIds'] = requestParameters['applicationIds'];
        }

        if (requestParameters['includeGlobalApplications'] != null) {
            queryParameters['includeGlobalApplications'] = requestParameters['includeGlobalApplications'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/access-requests/approved`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async apiAccessRequestsApprovedGetRaw(requestParameters: ApiAccessRequestsApprovedGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ApprovedAccessResponsePagedResult>> {
        const requestOptions = await this.apiAccessRequestsApprovedGetRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApprovedAccessResponsePagedResultFromJSON(jsonValue));
    }

    /**
     */
    async apiAccessRequestsApprovedGet(requestParameters: ApiAccessRequestsApprovedGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ApprovedAccessResponsePagedResult> {
        const response = await this.apiAccessRequestsApprovedGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for apiAccessRequestsAssignedUsersGet without sending the request
     */
    async apiAccessRequestsAssignedUsersGetRequestOpts(requestParameters: ApiAccessRequestsAssignedUsersGetRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['pageNumber'] != null) {
            queryParameters['PageNumber'] = requestParameters['pageNumber'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['PageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['sortOrder'] != null) {
            queryParameters['SortOrder'] = requestParameters['sortOrder'];
        }

        if (requestParameters['orderField'] != null) {
            queryParameters['OrderField'] = requestParameters['orderField'];
        }

        if (requestParameters['firstName'] != null) {
            queryParameters['firstName'] = requestParameters['firstName'];
        }

        if (requestParameters['surname'] != null) {
            queryParameters['surname'] = requestParameters['surname'];
        }

        if (requestParameters['roleIds'] != null) {
            queryParameters['roleIds'] = requestParameters['roleIds'];
        }

        if (requestParameters['applicationIds'] != null) {
            queryParameters['applicationIds'] = requestParameters['applicationIds'];
        }

        if (requestParameters['includeGlobalApplications'] != null) {
            queryParameters['includeGlobalApplications'] = requestParameters['includeGlobalApplications'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/access-requests/assigned-users`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async apiAccessRequestsAssignedUsersGetRaw(requestParameters: ApiAccessRequestsAssignedUsersGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ApprovedAccessResponsePagedResult>> {
        const requestOptions = await this.apiAccessRequestsAssignedUsersGetRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApprovedAccessResponsePagedResultFromJSON(jsonValue));
    }

    /**
     */
    async apiAccessRequestsAssignedUsersGet(requestParameters: ApiAccessRequestsAssignedUsersGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ApprovedAccessResponsePagedResult> {
        const response = await this.apiAccessRequestsAssignedUsersGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for apiAccessRequestsGet without sending the request
     */
    async apiAccessRequestsGetRequestOpts(requestParameters: ApiAccessRequestsGetRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['pageNumber'] != null) {
            queryParameters['PageNumber'] = requestParameters['pageNumber'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['PageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['sortOrder'] != null) {
            queryParameters['SortOrder'] = requestParameters['sortOrder'];
        }

        if (requestParameters['orderField'] != null) {
            queryParameters['OrderField'] = requestParameters['orderField'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/access-requests`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async apiAccessRequestsGetRaw(requestParameters: ApiAccessRequestsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AccessRequestResponsePagedResult>> {
        const requestOptions = await this.apiAccessRequestsGetRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AccessRequestResponsePagedResultFromJSON(jsonValue));
    }

    /**
     */
    async apiAccessRequestsGet(requestParameters: ApiAccessRequestsGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AccessRequestResponsePagedResult> {
        const response = await this.apiAccessRequestsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for apiAccessRequestsIdRequestExtensionPut without sending the request
     */
    async apiAccessRequestsIdRequestExtensionPutRequestOpts(requestParameters: ApiAccessRequestsIdRequestExtensionPutRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiAccessRequestsIdRequestExtensionPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/access-requests/{id}/request-extension`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async apiAccessRequestsIdRequestExtensionPutRaw(requestParameters: ApiAccessRequestsIdRequestExtensionPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AccessRequestResponse>> {
        const requestOptions = await this.apiAccessRequestsIdRequestExtensionPutRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AccessRequestResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiAccessRequestsIdRequestExtensionPut(requestParameters: ApiAccessRequestsIdRequestExtensionPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AccessRequestResponse> {
        const response = await this.apiAccessRequestsIdRequestExtensionPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for apiAccessRequestsPost without sending the request
     */
    async apiAccessRequestsPostRequestOpts(requestParameters: ApiAccessRequestsPostRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['accessRequestRequest'] == null) {
            throw new runtime.RequiredError(
                'accessRequestRequest',
                'Required parameter "accessRequestRequest" was null or undefined when calling apiAccessRequestsPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/access-requests`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AccessRequestRequestToJSON(requestParameters['accessRequestRequest']),
        };
    }

    /**
     */
    async apiAccessRequestsPostRaw(requestParameters: ApiAccessRequestsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AccessRequestResponse>> {
        const requestOptions = await this.apiAccessRequestsPostRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AccessRequestResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiAccessRequestsPost(requestParameters: ApiAccessRequestsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AccessRequestResponse> {
        const response = await this.apiAccessRequestsPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for apiAccessRequestsUuidStatusPreviewPost without sending the request
     */
    async apiAccessRequestsUuidStatusPreviewPostRequestOpts(requestParameters: ApiAccessRequestsUuidStatusPreviewPostRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['uuid'] == null) {
            throw new runtime.RequiredError(
                'uuid',
                'Required parameter "uuid" was null or undefined when calling apiAccessRequestsUuidStatusPreviewPost().'
            );
        }

        if (requestParameters['accessRequestUpdateStatusRequest'] == null) {
            throw new runtime.RequiredError(
                'accessRequestUpdateStatusRequest',
                'Required parameter "accessRequestUpdateStatusRequest" was null or undefined when calling apiAccessRequestsUuidStatusPreviewPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/access-requests/{uuid}/status/preview`;
        urlPath = urlPath.replace('{uuid}', encodeURIComponent(String(requestParameters['uuid'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AccessRequestUpdateStatusRequestToJSON(requestParameters['accessRequestUpdateStatusRequest']),
        };
    }

    /**
     */
    async apiAccessRequestsUuidStatusPreviewPostRaw(requestParameters: ApiAccessRequestsUuidStatusPreviewPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AccessRequestUpdateStatusNotificationPreviewResponse>> {
        const requestOptions = await this.apiAccessRequestsUuidStatusPreviewPostRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AccessRequestUpdateStatusNotificationPreviewResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiAccessRequestsUuidStatusPreviewPost(requestParameters: ApiAccessRequestsUuidStatusPreviewPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AccessRequestUpdateStatusNotificationPreviewResponse> {
        const response = await this.apiAccessRequestsUuidStatusPreviewPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for apiAccessRequestsUuidStatusPut without sending the request
     */
    async apiAccessRequestsUuidStatusPutRequestOpts(requestParameters: ApiAccessRequestsUuidStatusPutRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['uuid'] == null) {
            throw new runtime.RequiredError(
                'uuid',
                'Required parameter "uuid" was null or undefined when calling apiAccessRequestsUuidStatusPut().'
            );
        }

        if (requestParameters['accessRequestUpdateStatusRequest'] == null) {
            throw new runtime.RequiredError(
                'accessRequestUpdateStatusRequest',
                'Required parameter "accessRequestUpdateStatusRequest" was null or undefined when calling apiAccessRequestsUuidStatusPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/access-requests/{uuid}/status`;
        urlPath = urlPath.replace('{uuid}', encodeURIComponent(String(requestParameters['uuid'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: AccessRequestUpdateStatusRequestToJSON(requestParameters['accessRequestUpdateStatusRequest']),
        };
    }

    /**
     */
    async apiAccessRequestsUuidStatusPutRaw(requestParameters: ApiAccessRequestsUuidStatusPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AccessRequestUpdateStatusResponse>> {
        const requestOptions = await this.apiAccessRequestsUuidStatusPutRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AccessRequestUpdateStatusResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiAccessRequestsUuidStatusPut(requestParameters: ApiAccessRequestsUuidStatusPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AccessRequestUpdateStatusResponse> {
        const response = await this.apiAccessRequestsUuidStatusPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getAccessRequestByUuid without sending the request
     */
    async getAccessRequestByUuidRequestOpts(requestParameters: GetAccessRequestByUuidRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['uuid'] == null) {
            throw new runtime.RequiredError(
                'uuid',
                'Required parameter "uuid" was null or undefined when calling getAccessRequestByUuid().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/access-requests/{uuid}`;
        urlPath = urlPath.replace('{uuid}', encodeURIComponent(String(requestParameters['uuid'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getAccessRequestByUuidRaw(requestParameters: GetAccessRequestByUuidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AccessRequestResponse>> {
        const requestOptions = await this.getAccessRequestByUuidRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AccessRequestResponseFromJSON(jsonValue));
    }

    /**
     */
    async getAccessRequestByUuid(requestParameters: GetAccessRequestByUuidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AccessRequestResponse> {
        const response = await this.getAccessRequestByUuidRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
